module.exports = __webpack_public_path__ + "img/電気回路_5_8_3.2801643f.png";